<template>
  <div>
  <div class="login-page" v-if="showConf == false">
    <form>
      <!-- <p @click="closelogin" class="closelogin">x</p> -->
      <a @click="closelogin">
        <svg class="closelogin"><use xlink:href="#close"/></svg>
      </a>
      <div style="clear:both"/>
      <p class="login-title">Shopping Cart</p>
      <table class="table-wrapper">
        <tr>
          <th><input type="checkbox" @change="(e) => checkAll(e)"/></th>
          <th colspan="2">Product</th>
          <th>Price</th>
          <th>Quantity</th>
          <th>Total</th>
          <th>Action</th>
        </tr>
        <tr v-if="listNull">
          <td colspan="7" style="textAlign:center; fontStyle:italic; paddingTop:10px">There's no item in your cart.</td>
        </tr>
        <tr v-for="data in list">
          <td><input :value="data.product_id" v-model="checkList" type="checkbox"/></td>
          <td style="paddingTop: 20px"><img :src="data.website+data.img"></td>
          <td style="textAlign:left">{{data.name.length > 28?data.name.substring(0,28)+'...':data.name}}</td>
          <td>USD {{data.price}}</td>
          <td>
            <a @click="data.number == 1? data.number : sub(data.product_id, data.number)">
              <svg class="minus">
                <use xlink:href="#minus"/>
              </svg>
            </a>
            <!-- <p @click="data.number == 1? data.number : sub(data.product_id, data.number)" class="subs">-</p> -->
            <input type="text" v-model="data.number"/>
            <a @click="add(data.product_id, data.number)">
              <svg class="add">
                <use xlink:href="#plus"/>
              </svg>
            </a>
            <!-- <p @click="add(data.product_id, data.number)" class="add">+</p> -->
          </td>
          <td>USD {{data.price * data.number}}</td>
          <td>
            <p @click="remove(data)" class="delete">remove</p>
          </td>
        </tr>
      </table>
      <p class="grandTotal">Total item: {{totalPrice.number}} pc(s)</p>
      <p class="button" @click="order">Order</p>
    </form>
  </div>
  <confirm-payment @closePay="closelogin" @back="closeConf" fromSC="1" :pid="this.checkList" v-if="showConf"/>
  <!-- SVG -->
    <svg display="none">
      <symbol width="15px" height="15px" viewBox="0 0 41.756 41.756" id="close">
        <path d="M27.948,20.878L40.291,8.536c1.953-1.953,1.953-5.119,0-7.071c-1.951-1.952-5.119-1.952-7.07,0L20.878,13.809L8.535,1.465
          c-1.951-1.952-5.119-1.952-7.07,0c-1.953,1.953-1.953,5.119,0,7.071l12.342,12.342L1.465,33.22c-1.953,1.953-1.953,5.119,0,7.071
          C2.44,41.268,3.721,41.755,5,41.755c1.278,0,2.56-0.487,3.535-1.464l12.343-12.342l12.343,12.343
          c0.976,0.977,2.256,1.464,3.535,1.464s2.56-0.487,3.535-1.464c1.953-1.953,1.953-5.119,0-7.071L27.948,20.878z"/>
      </symbol>
      <symbol height="15px" viewBox="0 0 512 512" width="15px" xmlns="http://www.w3.org/2000/svg" id="plus">
        <path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469s132.667969-26.628906 181.019531-74.980469c48.351563-48.351562 74.980469-112.640625 74.980469-181.019531s-26.628906-132.667969-74.980469-181.019531zm-181.019531 397.019531c-119.101562 0-216-96.898438-216-216s96.898438-216 216-216 216 96.898438 216 216-96.898438 216-216 216zm20-236.019531h90v40h-90v90h-40v-90h-90v-40h90v-90h40zm0 0">
        </path>
      </symbol>
      <symbol height="15px" viewBox="0 0 512 512" width="15px" xmlns="http://www.w3.org/2000/svg" id="minus">
        <path d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
      </symbol>
    </svg>
    <!-- #### -->
</div>
</template>
<script>
import {GetCart, CartHandler} from '@/api/index.js'
import ConfirmPayment from './ConfirmPayment.vue'
  export default {
    name: 'ShoppingCart',
    data() {
      return {
        orderAmount:1,
        list: null,
        checkList:[],
        totalPrice:{
          number:0,
          price:0,
        },
        showConf:false,
        listNull:true,
      };
    },
    components:{
      ConfirmPayment,
    },
    watch: {
      checkList(v1,v2){
        let number = 0;
        let price = 0;
        let list = this.list;
        for( let key in v1){
          for(let k in list){
            if(v1[key] == list[k].product_id){
              number += parseInt(list[k].number);
              price += parseInt(list[k].price);
              break;
            }
          }
        }
        this.totalPrice.number = number;
        this.totalPrice.price = price;

      }
    },
    created(){
      this.initData();
    },
    methods:{
      initData(){
        GetCart({}).then(res => {
          this.list = res.data
          if (res.data.length != 0){
            this.listNull = false;
          } else{
            this.listNull = true;
          }
          if(res.data.number){
            this.orderAmount = res.data.number
          }
        })
      },
      closelogin(){
        this.$emit('close');
      },
      showRegister(){
        this.$emit('showRegister');
      },
      showForgot(){
        this.$emit('showForgot');
      },
      order(){
        this.showConf = true;
      },
      closeConf(){
        this.showConf = false;
      },
      remove(data){
        if(confirm('are you sure?')){
          CartHandler({'productid':data,'action':'del'}).then(res => {
            window.alert('1 item has been deleted from shopping cart');
            this.initData();
          })
        }
      },
      checkAll(e){
        let isChecked = e.srcElement.checked;
        if (isChecked){
          for(let i = 0; i < this.list.length; i++){
            if(this.checkList.indexOf(this.list[i].product_id) == -1){
              this.checkList.push(this.list[i].product_id);
            }
          }
        } else{
          this.checkList = [];
        }
      },
      add(id,number){
        let num = parseInt(number) + 1;
        CartHandler({'productid': id, 'action':'edit', 'number':num}).then(res => {
          console.log('ammount updated: ' + num);
          this.initData();
          this.checkList = [];
        })
      },
      sub(id, number){
        if(parseInt(number) > 0){
          let num = parseInt(number) - 1;
          CartHandler({'productid': id, 'action':'edit', 'number':num}).then(res => {
            console.log('ammount updated: ' + num);
            this.initData();
            this.checkList = [];
          })
        }
      },
    },
  };
</script>
<style lang="" scoped>
  .login-page{
    /* width:100%; */
    width:58%;
    margin:0 auto;
    position: fixed;
    background: #fff;
    box-shadow: 0px 8px 15px rgba(0,0,0,0.22);
    top:20vh;
    left:50%;
    transform: translateX(-50%);
    padding:30px;
    border-radius: 10px;
    max-height:600px;
    overflow: auto;
    z-index: 110;
  }
  input[type="text"]{
    padding:7px 10px;
    border:1px solid #d2d2d2;
    border-radius: 15px;
    width: 31%;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
  }

  input:focus{
    outline: none;
    /* border-color: red; */
  }
  .login-title{
    letter-spacing: 2px;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 50px;
    color:#3C4245;
  }
  .button{
    width: 23%;
    opacity: 1;
    color:#eee;
    background: #5F6769;
    float:right;
    line-height: 40px;
    border-radius: 15px;
  }
  .button:hover{
      cursor: pointer;
      background: #719192;
  }
  .closelogin{
    float:right;
    margin:10px 30px 0 0
  }
  .closelogin:hover{
    cursor: pointer;
  }
  img{
    width:50%;
    min-width: 46px;
  }
  .grandTotal{
    color: #3C4245;
    text-align: right;
    margin-bottom: 10px;
  }
  table{
    border-spacing: 0;
    /* background: #eee; */
    padding:10px;
    border-radius: 15px;
    margin-bottom: 20px;
    /* max-height: 308px; */
  }
  table th{
    padding-bottom: 20px;
    border-bottom: 1px solid #000;
    width: 200px;
  }
  table td{
    /* padding:5px; */
      width: 200px;
    margin-bottom: 1px solid #000;
    /* vertical-align: middle; */
    /* display: inline-block; */
  }
  table th td{
    overflow: auto;
  }

  .closelogin{
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0;
  top: 10px;
  margin:10px 30px 0 0
}
.closelogin:hover{
    fill: #719192;
    cursor: pointer;
}
.delete{
  padding:5px 0;
  width: 80%;
  margin:0 auto;
  border-radius: 15px;
  color:#eee;
  background: #9D9D9D;
}
.delete:hover{
  background: #719192;
  cursor: pointer;
}
.add,.minus{
  fill: #5F6769;
  width: 15px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
}
.add:hover,.minus:hover{
  cursor: pointer;
    fill: #719192;

}
</style>



// WEBPACK FOOTER //
// src/components/ShoppingCart.vue